import { Dialog, DialogActions, DialogContent, DialogProps, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../types'
import AppButton from '../Button/AppButton'
import ModalTitle from './ModalTitle'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        "& .MuiDialog-paperScrollPaper": {
            minWidth: '25rem',
            minHeight: '10rem',
            background: theme.palette.background.default,
            zIndex: 9999,
        },
        "& .MuiPaper-rounded": {
            borderRadius: "8px"
        },

        [theme.breakpoints.down('xs')]: {
            "& .MuiDialog-paperScrollPaper": {
                minWidth: '90%',
            }
        }
    },
    content: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.paper
    },
    actions: {
        padding: theme.spacing(2),
    }
}))



interface Props extends DialogProps {
    showActions?: boolean;
    hideCloseActionButton?: boolean;
    ActionComponent?: React.ReactNode;
    hideCloseButton?: boolean;
    hideModalHeader?: boolean;
}

const AppModal: React.FC<Props> = ({
    children,
    onClose,
    title,
    showActions,
    hideCloseActionButton = false,
    ActionComponent,
    hideCloseButton = false,
    hideModalHeader = false,
    ...props
}) => {
    const classes = useStyles();
    const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode)

    const handleOnClick = (e: {}) => {
        if (onClose) onClose(e, "backdropClick")
    }

    return (
        <Dialog
            onClose={onClose}
            {...props}
        >
            {
                !hideModalHeader ?
                    <ModalTitle onClose={onClose} hideCloseButton={hideCloseButton}>
                        {title}
                    </ModalTitle> : null
            }
            {
                children ? (
                    <DialogContent className={classes.content}>{children}</DialogContent>
                ) : null
            }

            {
                showActions && (

                    <DialogActions className={classes.actions}>
                        {
                            !hideCloseActionButton ? (
                                <AppButton
                                    onClick={handleOnClick}
                                    color="primary"
                                    variant='contained'
                                    disableElevation
                                >
                                    Close
                                </AppButton>
                            ) : null
                        }
                        {ActionComponent}
                    </DialogActions>
                )
            }
        </Dialog>
    )
}

export default AppModal
